<template>
    <div class="modal" :id="modalId">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        {{ dowName }}
                    </h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">

                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">od</span>
                        </div>
                        <input class="form-control" type="time" v-model="fromTimeValue" ref="time-input-from">
                        <div class="input-group-prepend">
                            <span class="input-group-text">do</span>
                        </div>
                        <input class="form-control" type="time" v-model="toTimeValue" ref="time-input-to">
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">miejsce</span>
                        </div>
                        <select class="form-control" ref="select-place" v-model="placeName">
                            <option v-for="place in places">{{place.name}}</option>
                        </select>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">tygodnie</span>
                        </div>
                        <select class="form-control" ref="select-parity" v-model="weekParityName">
                            <option v-for="weekPar in weekParity">{{weekPar.name}}</option>
                        </select>
                    </div>
                    <div class="alert alert-danger my-2" role="alert" v-show="validationError">
                        Czas <b>od</b> musi być wczesniejszy niż <b>do</b>.
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-orange" data-dismiss="modal" @click="submit"
                            v-bind:disabled="validationError">Zapisz
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {backend} from '../../backend';
    import Constants from '../../constants.js';

    moment.locale('pl');

    export default {
        name: "WorktimeFormModal",
        props: {
            modalId: {
                type: String,
                required: true
            },
            dow: {
                type: Number,
                required: true
            },
            fromTimeValueDefault: {
                type: String,
                required: true
            },
            toTimeValueDefault: {
                type: String,
                required: true
            },
            places: {
                type: Array,
                required: true
            },
            plan: Object,
        },
        data() {
            return {
                fromTimeValue: '',
                toTimeValue: '',
                placeName: '',
                weekParityName: '',
                weekParity: Constants.get('IA_WORKPLAN_WEEK_PARITY'),
                dowName: moment.weekdays(true)[this.dow - 1],
            }
        },
        created() {
            this.reset();
        },
        watch: {
            fromTimeValueDefault: function (newVal) {
                this.fromTimeValue = newVal;
            },
            toTimeValueDefault: function (newVal) {
                this.toTimeValue = newVal;
            },
            plan: function (newVal) {
                this.placeName = this.places.find(e => e.id === newVal.place).name;
                this.weekParityName = this.weekParity[newVal.week_id].name
            }
        },
        computed: {
            validationError: function () {
                return this.toTimeValue <= this.fromTimeValue;
            }
        },
        methods: {
            reset: function () {
                this.fromTimeValue = this.fromTimeValueDefault;
                this.toTimeValue = this.toTimeValueDefault;
                this.placeName = this.plan ? this.places.find(e => e.id === this.plan.place).name
                                           : this.places[0].name;
                this.weekParityName = this.plan ? this.weekParity[this.plan.week_id].name
                                                : this.weekParity[1].name;
            },
            timeToMinutes: time => parseInt(time.substring(0, 2)) * 60 + parseInt(time.substring(3, 5)),
            createWorkTimePlan: function (data) {
                backend.createWorktimePlan(data)
                    .then(response => {
                        this.$emit('created', response.data);
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się stworzyć nowego planu.', color: 'danger'});
                    })
                    .then(() => {
                        this.reset();
                    });
            },
            updateWorkTimePlan: function (id, data) {
                backend.updateWorktimePlan(id, data)
                    .then(response => {
                        this.$emit('updated', response.data);
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się zaktualizować planu.', color: 'danger'});
                    })
                    .then(() => {
                        this.reset();
                    });
            },
            submit: function () {
                const place = this.places.find(el => el.name === this.placeName);
                const weekParityId = Object.keys(this.weekParity)
                                           .find(key => this.weekParity[key].name === this.weekParityName);
                const data = {
                    'dow': this.dow,
                    'from_hour': this.timeToMinutes(this.fromTimeValue),
                    'to_hour': this.timeToMinutes(this.toTimeValue),
                    'place': place.id,
                    'week_id': weekParityId,
                };
                if (this.plan)
                    this.updateWorkTimePlan(this.plan.id, data);
                else
                    this.createWorkTimePlan(data);
            }
        },
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// WorktimeFormModal.vue?5feb453f